import FeatureReferenceQueryPatternType from './FeatureReferenceQueryPatternType.js';
import patterns from './patterns.js';
/**
 * @memberof feature-references
 * @property {feature-references.FeatureReferenceQueryPatternType} pattern
 * @property {feature-references.SpatialQueryParameters} parameters
 */
class FeatureReferenceQuery {
    /**
     * @param {object} props
     * @param {feature-references.FeatureReferenceQueryPatternType} props.pattern
     * @param {feature-references.SpatialQueryParameters} props.parameters
     */
    constructor(props) {
        if (props && props.pattern) {
            this.pattern = props.pattern;
            const PatternParameters = patterns.byPatternType[this.pattern];
            this.parameters = new PatternParameters(props.parameters);
        }
    }
    /**
     * We know a query is "empty" or "inactive" if there is no pattern
     * @type {boolean}
     */
    get isEmpty() {
        return !this.pattern;
    }
    /**
     * @return {Promise.<feature-references.FeatureReference[]>}
     */
    evaluate() {
        return this.parameters.evaluate();
    }
}
/**
 * @type {feature-references.FeatureReferenceQueryPatternType}
 */
FeatureReferenceQuery.PatternType = FeatureReferenceQueryPatternType;
/**
 * @type {object}
 */
FeatureReferenceQuery.patterns = patterns;
export default FeatureReferenceQuery;
